import RetargetingListList from 'common/pages/retargeting-list/RetargetingListList'

export const RetargetingListListAdvertiser = (props) => <RetargetingListList {...props} />
